import _objectSpread from "/Users/fafee/Work/Loginet/InternalPortal/internal-portal/portal-client/node_modules/.pnpm/@babel+runtime@7.28.4/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.number.constructor.js";
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { onMounted, onUnmounted, inject, watch } from "vue";
import DateRangeSelector from "@/components/ui/date-range/DateRangeSelector.vue";
import { useDailyDateRange } from "@/composables/useDailyDateRange.ts";
export default {
  __name: 'DailyDateRangeSelector',
  props: {
    initialSelectedDay: {
      type: Date,
      required: false,
      default: null
    },
    selectedDay: {
      type: Object,
      required: false,
      default: null
    },
    dayRangeLength: {
      type: Number,
      required: false,
      default: 8
    }
  },
  emits: ["update:selected-day"],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var requestStartDate = inject("requestStartDate");
    var props = __props;
    var emit = __emit;

    // Use the daily date range composable
    var _useDailyDateRange = useDailyDateRange(props.dayRangeLength),
      currentDay = _useDailyDateRange.currentDay,
      isPreviousDisabled = _useDailyDateRange.isPreviousDisabled,
      getDailyRange = _useDailyDateRange.getDailyRange,
      prevDay = _useDailyDateRange.previousDay,
      nextDayFn = _useDailyDateRange.nextDay,
      resetDay = _useDailyDateRange.resetToCurrentDay,
      setDay = _useDailyDateRange.setDay;

    // Emit day update with the current day data
    var emitDayUpdate = function emitDayUpdate() {
      var dailyRange = getDailyRange(props.dayRangeLength);
      emit("update:selected-day", _objectSpread({}, dailyRange));
    };
    watch(requestStartDate, function () {
      setDay(requestStartDate.value);
      emitDayUpdate();
    }, {
      immediate: false
    });

    // Wrapper functions to emit updates
    var previousDay = function previousDay() {
      prevDay();
      emitDayUpdate();
    };
    var nextDay = function nextDay() {
      nextDayFn();
      emitDayUpdate();
    };
    var resetToCurrentDay = function resetToCurrentDay() {
      resetDay();
      emitDayUpdate();
    };

    // Initialize with current day
    onMounted(function () {
      // Only set current day if no prop value is provided
      if (!props.initialSelectedDay) {
        // Initialize with 2 days ago
        currentDay.value = new Date(new Date().setDate(new Date().getDate() - 2));
        emitDayUpdate();
      } else {
        setDay(props.initialSelectedDay);
        emitDayUpdate();
      }
    });
    onUnmounted(function () {
      resetToCurrentDay();
    });
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", null, [_createVNode(DateRangeSelector, {
        "display-label": _unref(getDailyRange)().label,
        "is-previous-disabled": _unref(isPreviousDisabled),
        "previous-label": _ctx.$tf('timeManagement.previousDay.label'),
        "next-label": _ctx.$tf('timeManagement.nextDay.label'),
        "previous-tooltip": _ctx.$tf('timeManagement.previousDay.tooltip'),
        "next-tooltip": _ctx.$tf('timeManagement.nextDay.tooltip'),
        onPrevious: previousDay,
        onNext: nextDay,
        onReset: resetToCurrentDay,
        "width-of-label": "225px"
      }, null, 8, ["display-label", "is-previous-disabled", "previous-label", "next-label", "previous-tooltip", "next-tooltip"])]);
    };
  }
};